import { FormControlLabel, FormControlLabelProps, Radio, RadioProps } from "@mui/material";

interface IRadioWithLabelProps extends Omit<FormControlLabelProps, "control"> {
    radioProps?: RadioProps;
    size?: RadioProps["size"];
}

export const RadioWithLabel = ({ radioProps, slotProps, size, sx, ...props }: IRadioWithLabelProps) => (
    <FormControlLabel
        control={<Radio size={size} {...radioProps} />}
        {...props}
        sx={{ marginLeft: "0", ...sx }}
        slotProps={{ typography: { fontSize: size === "small" ? "sm" : "md", marginLeft: 1 }, ...slotProps }}
    />
);
